import { useCallback, useRef } from 'react';
import { pruneNilValues } from '@core/object';
import { PRODUCT_CARD_IMPRESSION } from '@core/shopping/tracking/endpoints';
import { sendPixelTrackingWithSession } from '@core/tracking';
import { customEmbedEvent, EventType } from '@embed/customEmbedEvent';
import { useTracking } from './useTracking';
/**
 * Hook that provides a callback for tracking of product card impression
 * pixel event for thumbnail.
 */
export const useTrackProductCardImpression = (video) => {
    const { params, pixelTrackingData } = useTracking();
    const timeoutByProduct = useRef({});
    return useCallback((isVisible, product) => {
        clearTimeout(timeoutByProduct.current[product.product_id]);
        if (isVisible) {
            timeoutByProduct.current[product.product_id] = setTimeout(() => {
                const { encoded_id, variant } = video ?? {};
                const pixelData = {
                    event_properties: pruneNilValues({
                        ...pixelTrackingData,
                        variant,
                        _video_id: encoded_id,
                        product,
                    }),
                };
                customEmbedEvent({
                    type: EventType.FW_SHOPPING_PRODUCT_CARD_IMPRESSION,
                    data: { product, product_id: product.product_id },
                    params,
                });
                sendPixelTrackingWithSession({
                    host: params?.api_host_tracking,
                    endpoint: PRODUCT_CARD_IMPRESSION,
                    data: pixelData,
                });
            }, 1000);
        }
    }, [params, pixelTrackingData, video]);
};
